import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import BuyButton from './BuyButton';

const ComplimentaryProducts = () => {
    const cart = useSelector((state) => state.cart);
    const { complimentaryProducts } = cart;
    return (
        complimentaryProducts && complimentaryProducts.length > 0 &&
        <div className="complimentary-products">
            <h3 className="checkout__section-title">{translate('checkout.complimentaryproduct')}</h3>
            <ul className={`complimentary-products__list ${complimentaryProducts.length > 6 ? "complimentary-products__list--scroll" : ""}`}>
                {complimentaryProducts.map((product, index) => (
                    <li className="complimentary-products__product" key={index}>
                        <figure className="complimentary-products__figure">
                            <img src={product.imageUrl} />
                        </figure>
                        <a href={product.url} className="complimentary-products__link">
                            <h4 className="complimentary-products__product-name">{product.name}</h4>
                            <span className="complimentary-products__product-price">
                                {
                                    product.price != undefined &&
                                    (product.price.campaignPrice != undefined || '' ?
                                        <div>
                                            <span className="product__campaign-price">
                                                {product.price.formattedCampaignPrice}
                                            </span> &nbsp;
                                            <span className="product__old-price">
                                                {product.price.formattedPrice}
                                            </span>
                                        </div>
                                        :
                                        <div>
                                            <span className="product__price">
                                                {product.price.formattedPrice}
                                            </span>
                                        </div>
                                    )
                                }
                            </span>
                        </a>
                        <buy-button>
                            <BuyButton
                                articleNumber={product.id}
                                cssClass="button product__buy-button buy-button--icon"
                                label={translate('product.buy')}
                                checkoutPage={true}
                            ></BuyButton>
                        </buy-button>
                    </li>
                ))
                }
            </ul>
        </div>
    );
};
export default ComplimentaryProducts;
